import { ck, URLS } from "fire-wind-water";
import URL from "../assets/conf/setting.json";
import $ from "jquery";
import { createField, updateDirty } from "../../stempcore/src/core/sfield";
import { resetURL, setUploadURL, setURL } from "../../stempcore/src/sbase";

ck.json = true;
const tenantId = URLS.getURL("tenantId");
const sourceKey = URLS.getURL("sourceKey");
const instanceId = URLS.getURL("instanceId");
const webinarId = URLS.getURL("webinarId");
const customFormId = URLS.getURL("customFormId");
const tc = URLS.getURL("tc");
const markCode = URLS.getURL("markCode");
const linkId = URLS.getURL("linkId");
const fileUrl = URL.sbaseUrl;
const markType = URLS.getURL("markType");
resetURL(URL);
setUploadURL(URL.template.api.ungateway.contentUrl);
setURL(URL.template.api.gateway.general + "/");

const showShareTip = function() {
  if ($("body").find("#wechat-share-tip").length == 0) {
    $(
      '<div class="m-alert-modal modal fade" id="wechat-share-tip" style="display: flex;align-items: center;justify-content: center;background-color: rgba(0,0,0,0.6);"> <div style="background: rgba(51,51,51,0.6) url(' +
        require("@/assets/images/share-tip.png") +
        ') 0px -0.6rem no-repeat ;background-size: 100%;width: 100%;height: 100%;position: fixed;bottom: 0;left: 0;z-index: 1001;"></div></div>'
    ).appendTo("body");
    $("#wechat-share-tip").show();
  }
  $("#wechat-share-tip").click(function() {
    $("#wechat-share-tip").hide();
  });
};

export {
  tenantId,
  sourceKey,
  tc,
  markCode,
  instanceId,
  webinarId,
  customFormId,
  fileUrl,
  linkId,
  markType,
  createField,
  updateDirty,
  showShareTip
};
